import React, {Component} from 'react';
import {Field, reduxForm, reset} from 'redux-form';
import {connect} from 'react-redux';
import _, { reject } from 'lodash';

import Utils from '../../../../lib/utils';
import renderField from '../../../customInputs/renderField';
import renderSelect from '../../../customInputs/renderSelect';
import FilterActions from '../../../common/filterActions/FilterActions';
import * as filterActions from '../../filterbox/actions';
import moment from "moment";
import { bindActionCreators } from 'redux';
import * as actions from '../actions';
import { CERTFOCUS_TASK_FINISHED_ID } from '../../../../lib/appConstants';

class FilterNotesTasks extends Component {
  constructor(props) {
    super(props);
    this.filtersResetCallback = this.filtersResetCallback.bind(this)
    this.handPreloadFilters()
  }

  async handPreloadFilters() {
    const { fromProject, fromInsuredTab, fromHolderTab } = this.props;
    if (this.props.form === 'FilterCFTasks') {
      if (this.props.fromGlobalModule && !fromProject && !fromInsuredTab && !fromHolderTab) {
        let saveFilter = { tab: 'task' }
        saveFilter.module = 'GobalTasks'
        saveFilter.objectId = null;
        await this.props.filterActions.fetchDefaultFilters(saveFilter, 'FilterCFTasks', async (filters) => {
          if (filters && typeof filters == 'object') {
            await this.props.getInitialData({ ...filters, assignedTo: filters.assignedToUserId, keywords: filters.searchTerm, notSaveFilters: true })
          } else {
            await this.props.getInitialData({ notSaveFilters: true })
          }
        });
      } else {
        this.props.getInitialData({})
      }
    }
  }

  async filtersResetCallback(values) {
    values.preventDefault()
    const saveFilterPromise = new Promise(async (resolve, reject) => {
      return resolve(await this.props.getInitialData({reset: true}))
    })
    Promise.all([saveFilterPromise])
  }

  render() {
    const {handleSubmit, tasks, fromInsuredTab, fromHolderTab, canSeeUserList} = this.props;

    const {
      statusPossibleValues,
      cfRolesPossibleValues,
    } = tasks;

    const {
      title,
      keywords,
      dateDueFrom,
      dateDueTo,
      assignedToUser,
      assignedToRole,
      status,
      priority,
      type,
      departments,
      holderKeywords,
      insuredKeywords,
    } = this.props.locale;
    const {CFRole} = this.props.profile;
    let users = [];
    // Assigned to options
    const usersList = this.props.tasks.users;
    if(usersList && usersList.length > 0 && CFRole && CFRole.Name === 'Holder View Only'){
     let findUser =  usersList.find(x => x.id === this.props.profile.Id);
     if(findUser){
      users.push(findUser)
     }
    }else{
      users = usersList
    }
    const assignedOptionsList = Utils.getOptionsList(assignedToUser.ph, users, 'name', 'id', 'name', '');
    const assignRoleOptionsList = Utils.getOptionsList(assignedToRole.ph, cfRolesPossibleValues, 'name', 'id', 'name');
    const statusOptionsList = Utils.getOptionsList(status.ph, statusPossibleValues, 'status', 'id', 'name');

    const taskPriorityOptions = Utils.getOptionsList(priority.ph, this.props.tasks.taskPriorityPossibleValues, 'name', 'id', 'name', '');
    const taskTypesOptions = Utils.getOptionsList(type.ph, this.props.tasks.taskTypesPossibleValues, 'type', 'id', 'type', '');

    const departmentsOptions = Utils.getOptionsList(departments.ph, this.props.departments, 'name', 'id', 'name', '');

    return (
      <form onSubmit={handleSubmit} className="list-view-filter-form" style={{backgroundColor: 'white'}}>
        <h2 className="list-view-filter-title">{title}</h2>
        <div className="container-fluid filter-fields">
          <div className="row">
            <div className="col-md-4 col-sm-12 no-padding">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="keywords">{keywords.label}: </label>
                <Field
                  name="keywords"
                  type="text"
                  placeholder={`-- ${keywords.ph} --`}
                  component={renderField}
                  className="tags-input"
                />
              </div>
            </div>

            <div className="col-md-2 col-sm-12 no-padding">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="holderKeyword">{holderKeywords.label}: </label>
                {fromHolderTab?
                  <Field
                    name="holderKeyword"
                    type="text"
                    placeholder={`-- ${holderKeywords.ph} --`}
                    component={renderField}
                    className="tags-input"
                    disabled
                  />
                :
                  <Field
                    name="holderKeyword"
                    type="text"
                    placeholder={`-- ${holderKeywords.ph} --`}
                    component={renderField}
                    className="tags-input"
                  />
                }
              </div>
            </div>
            <div className="col-md-2 col-sm-12 no-padding">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="insuredKeyword">{insuredKeywords.label}: </label>

                {(fromInsuredTab)?
                  <Field
                    name="insuredKeyword"
                    type="text"
                    placeholder={`-- ${insuredKeywords.ph} --`}
                    component={renderField}
                    className="tags-input"
                    disabled
                  />
                  :
                  <Field
                    name="insuredKeyword"
                    type="text"
                    placeholder={`-- ${insuredKeywords.ph} --`}
                    component={renderField}
                    className="tags-input"
                  />
                }


              </div>
            </div>

            <div className="col-md-2 col-sm-12 no-padding">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="dateFrom">{dateDueFrom.label}: </label>
                <Field
                  name="dateFrom"
                  type="date"
                  // defaultValue={moment().format('YYYY-MM-DD')}
                  component={renderField}
                  className="tags-input"
                />
              </div>
            </div>
            <div className="col-md-2 col-sm-12 no-padding">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="dateTo">{dateDueTo.label}: </label>
                <Field
                  name="dateTo"
                  type="date"
                  component={renderField}
                  // defaultValue={moment().format('YYYY-MM-DD')}
                  className="tags-input"
                />
              </div>
            </div>

          </div>
          <div className="row">

            <div className="col-md-2 col-sm-12 no-padding">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="departmentId">{departments.label}: </label>
                <div className="select-wrapper">
                  <Field
                    name="departmentId"
                    component={renderSelect}
                    options={departmentsOptions}/>
                </div>
              </div>
            </div>

            {(canSeeUserList)
              ? <div className="col-md-2 col-sm-12 no-padding">
                <div className="admin-form-field-wrapper keywords-field">
                  <label htmlFor="assignedTo">{assignedToUser.label}: </label>
                  <div className="select-wrapper">
                    <Field
                      name="assignedTo"
                      component={renderSelect}
                      options={assignedOptionsList}/>
                  </div>
                </div>
              </div>
              : null
            }

            {!_.isEmpty(cfRolesPossibleValues) && (canSeeUserList) &&
            <div className="col-md-2 col-sm-12 no-padding">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="assignedToRoleId">{assignedToRole.label}: </label>
                <div className="select-wrapper">
                  <Field
                    name="assignedToRoleId"
                    component={renderSelect}
                    options={assignRoleOptionsList}/>
                </div>
              </div>
            </div>
            }

            <div className="col-md-2 col-sm-12 no-padding">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="statusId">{status.label}: </label>
                <div className="select-wrapper">
                  <Field
                    name="statusId"
                    component={renderSelect}
                    options={statusOptionsList}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-2 col-sm-12 no-padding">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="tasksPriorityId">{priority.label}: </label>
                <div className="select-wrapper">
                  <Field
                    name="tasksPriorityId"
                    component={renderSelect}
                    options={taskPriorityOptions}/>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-sm-12 no-padding">
              <div className="admin-form-field-wrapper keywords-field">
                <label htmlFor="typeId">{type.label}: </label>
                <div className="select-wrapper">
                  <Field
                    name="typeId"
                    component={renderSelect}
                    options={taskTypesOptions}/>
                </div>
              </div>
            </div>

          </div>
          <div className="row">
            <div className="col-12 no-padding">
              <div className="admin-form-field-wrapper">
                <FilterActions
                  formName={this.props.form}
                  dispatch={this.props.dispatch}
                  filtersResetCallback={this.filtersResetCallback}
                />
              </div>
            </div>
          </div>
        </div>
      </form>

    );
  }
}

FilterNotesTasks = reduxForm({
  form: 'FilterCFTasks',
  enableReinitialize : true,
})(FilterNotesTasks);

const mapStateToProps = (state, props) => {
  const { filterbox } = state.filterBox;

  let initialValueState = {};
  if (filterbox && filterbox.FilterCFTasks && typeof filterbox.FilterCFTasks === 'object') {
    const { searchTerm, insuredKeyword, holderKeyword, assignedToUserId } = filterbox.FilterCFTasks;
    initialValueState = {
      keywords: searchTerm ? searchTerm : props.insuredName,
      insuredKeyword: insuredKeyword ? insuredKeyword : props.insuredName,
      holderKeyword: holderKeyword ? holderKeyword : props.holderName,
      assignedTo: assignedToUserId,
      canSeeUserList: props.canSeeUserList,
      ...filterbox.FilterCFTasks
    }
  } else {
    initialValueState = {
      insuredKeyword: props.insuredName,
      holderKeyword: props.holderName,
      assignedTo: props.userId,
      canSeeUserList: props.canSeeUserList,
      dateFrom: moment().format('YYYY-MM-DD'),
    }
  }

  return {
    users: state.users,
    local: state.localization,
    locale: state.localization.strings.CFTasks.filter,
    departments: state.departments.list,
    tasks: state.CFTasks,
    initialValues: initialValueState,
    profile: state.login.profile
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    filterActions: bindActionCreators(filterActions, dispatch),
    actions: bindActionCreators(actions, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FilterNotesTasks);
